import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material';

const operationTypeLabelMap = {
    t: 'Retail',
    r: 'Restaurante',
    h: 'Hotel',
    a: 'Renta de auto'
};

const getOperationTypeLabel = (value) => operationTypeLabelMap[(value || '').toLowerCase()] || '-';

const CreateMerchantForm = ({ onMerchantCreated, createMerchant, affiliations, initialValues, submitLabel, title }) => {
    const [name, setName] = useState(initialValues?.name || '');
    const [street, setStreet] = useState(initialValues?.street || '');
    const [number, setNumber] = useState(initialValues?.number || '');
    const [city, setCity] = useState(initialValues?.city || '');
    const [state, setState] = useState(initialValues?.state || '');
    const [country, setCountry] = useState(initialValues?.country || '');
    const [zip, setZip] = useState(initialValues?.zip || '');
    const [affiliationId, setAffiliationId] = useState(initialValues?.affiliation_id ? String(initialValues.affiliation_id) : '');
    const [subMerchantId, setSubMerchantId] = useState(initialValues?.sub_merchant_id || '');
    const [subMerchantCategoryCode, setSubMerchantCategoryCode] = useState(initialValues?.sub_merchant_category_code || '');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!affiliationId) {
            setError('Debes seleccionar una afiliación.');
            return;
        }

        try {
            await createMerchant({
                name,
                street,
                number,
                city,
                state,
                country,
                zip,
                affiliation_id: Number.parseInt(affiliationId, 10),
                sub_merchant_id: subMerchantId.trim(),
                sub_merchant_category_code: subMerchantCategoryCode.trim()
            });
            onMerchantCreated();
        } catch (err) {
            setError('No se pudo crear el comercio.');
            console.error(err);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Typography variant="h6">{title || 'Crear nuevo comercio'}</Typography>
            {error && <Typography color="error">{error}</Typography>}
            <TextField label="Nombre" value={name} onChange={(e) => setName(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Calle" value={street} onChange={(e) => setStreet(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Número" value={number} onChange={(e) => setNumber(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Ciudad" value={city} onChange={(e) => setCity(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Estado" value={state} onChange={(e) => setState(e.target.value)} fullWidth required margin="normal" />
            <TextField label="País" value={country} onChange={(e) => setCountry(e.target.value)} fullWidth required margin="normal" />
            <TextField label="Zip" value={zip} onChange={(e) => setZip(e.target.value)} fullWidth required margin="normal" />
            <FormControl fullWidth margin="normal" required>
                <InputLabel>Afiliación</InputLabel>
                <Select
                    value={affiliationId}
                    label="Afiliación"
                    onChange={(e) => setAffiliationId(e.target.value)}
                >
                    {affiliations.map((affiliation) => (
                        <MenuItem key={affiliation.id} value={affiliation.id}>
                            {affiliation.nombre} - {getOperationTypeLabel(affiliation.tipo_operacion)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                label="Sub-Merchant ID"
                helperText="6 a 9 dígitos. Sólo para agregadores (Copayment aggregatorData)."
                value={subMerchantId}
                onChange={(e) => setSubMerchantId(e.target.value)}
                inputProps={{ maxLength: 9, pattern: '[0-9]*' }}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Sub-Merchant Category Code"
                helperText="4 dígitos (MCC). Opcional."
                value={subMerchantCategoryCode}
                onChange={(e) => setSubMerchantCategoryCode(e.target.value)}
                inputProps={{ maxLength: 4, pattern: '[0-9]*' }}
                fullWidth
                margin="normal"
            />
            <Button type="submit" variant="contained" sx={{ mt: 2 }}>
                {submitLabel || 'Crear'}
            </Button>
        </Box>
    );
};

export default CreateMerchantForm;
